import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

type Props = {};

const CpdTabScrollStyle = styled(Box)<Props>(
  ({ theme }) => `
    width: 100%;
    background-color: #F5F5F5;
    z-index: 1;
    transition: top 0.6s;
    .container {
      max-width: 1180px;
    }

  ${theme.breakpoints.up('lg')} {
    .container {
      margin: 0 auto;
      height: 100%;
      padding: 0rem 1rem;
      position: relative;
    }
  }
  ${theme.breakpoints.down('lg')} {
    .container {
      margin: 0rem auto;
      height: 100%;
      padding: 0 1rem;
    }
  }
  ${theme.breakpoints.down('md')} {
    .container {
      margin: 0 0.5rem;
      height: 100%;
      padding: 0 0;
    }
  }
  }
`,
);

export default CpdTabScrollStyle;
